import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  min-width: 1160px;
  width: auto;
  background: linear-gradient(90deg, #7aabf3 0%, #2765be 100%);
  border-radius: 10px;
  overflow: hidden;
  height: 86px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  &.clickable {
    cursor: pointer;

    :hover {
      button {
        color: #000000;
        background: #ffffff;
      }
    }
  }

  img {
    pointer-events: none;
    z-index: 0;
    //width: 100%;
    //min-width: 100%;
    //min-height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: auto;
    min-height: 100%;
    width: 100%;
    min-width: 100%;
  }

  .title {
    color: #fff;
    font-size: 40px;
    font-weight: 600;
    line-height: 56px;
    text-align: left;
    padding: 0 0 0 20px;
    position: relative;
    width: 650px;
    flex: 0 0 auto;
  }

  .subtitle {
    color: #fff;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    text-align: left;
    padding: 0;
    position: relative;
    width: 470px;
    flex: 0 0 auto;
  }

  .third {
    width: 400px;
    flex: 0 0 auto;
  }

  button {
    position: absolute;
    right: 20px;
    top: 50%;
    margin-top: -15px;
    font-size: 12px;
    font-weight: 500;
    line-height: 15.6px;
    text-align: center;
    color: #ffffff;
    background: transparent;
    border: 1px solid #ffffff;
    border-radius: 5px;
    padding: 7px 15px;
  }
`;
